/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
// Sector.icon, Supplier.logo, and Product.image hold either a plain emoji
// (legacy/seed data, or an admin who just typed one) or a path/URL to an
// admin-uploaded image. Render whichever it actually is.
export function isUploadedImage(value) {
    if (!value)
        return false;
    return value.startsWith('/uploads/') || value.startsWith('http://') || value.startsWith('https://') || value.startsWith('data:image/');
}
export default function EntityIcon({ value, alt = '', size = 32, className = '' }) {
    if (isUploadedImage(value)) {
        return (
        <img src={value} alt={alt} width={size} height={size} style={{ width: size, height: size }} className={`object-cover rounded-lg inline-block shrink-0 ${className}`}/>);
    }
    return <>{value}</>;
}
